(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"] && !Shopify.designMode) return;
  try {
    

function agegate() {
    let ag = document.querySelector('#agegate');
    if(!ag) return;
    let button = ag.querySelector('#verify')
    if(!button) return;

    let untamedCookie = getCookie('untamedAG');
    console.log("UTC",untamedCookie);

    if (untamedCookie !== null) {
        console.log('Untamed cookie found');
        agDestroy();
    } else {
        agShow();
        button.addEventListener('click', processAgreement)
    }

    function processAgreement() {
        setCookieWithMaxAge('untamedAG',"true",86400); // Expires in 1 day
        console.log("adding UT cookie for 1 day");
        agHide();
        setTimeout(agDestroy,500);
    }

    function agShow() {
        ag.classList.add('show');
    }

    function agHide() {
        ag.classList.remove('show');
    }

    function agDestroy() {
        ag.remove();
    }

}

function setCookieWithMaxAge(name, value, seconds) {
  const maxAge = "max-age=" + seconds;
  document.cookie = name + "=" + value + ";" + maxAge + ";path=/";
}

function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim(); // Remove leading/trailing whitespace
    // Check if this cookie starts with the desired name and an equals sign
    if (cookie.startsWith(name + '=')) {
      // Return the value of the cookie
      return cookie.substring(name.length + 1);
    }
  }
  return null; // Return null if the cookie is not found
}

function quickModalWorkings() {
  const privacyTrigger = document.getElementById('privacyPolicyTrigger');
  const termsTrigger = document.getElementById('termsPolicyTrigger');
  const dialogPrivacy = document.getElementById("privacyDialog");
  const dialogTerms = document.getElementById("termsDialog");

  if (!dialogPrivacy && !dialogTerms) {
    console.log("No dialog found");
    return;
  }

  if (privacyTrigger) {
    privacyTrigger.addEventListener('click', () => {
      dialogPrivacy.show();
    });
  }

  if (termsTrigger) {
    termsTrigger.addEventListener('click', () => {
      dialogTerms.show();
    });
  }

  const closeButtonPrivacy = dialogPrivacy.querySelector('button[autofocus]');
  if (closeButtonPrivacy) {
    closeButtonPrivacy.addEventListener('click', () => {
      dialogPrivacy.close();
      closeButtonPrivacy.removeEventListener('click', this);
    });
  }

  const closeButtonTerms = dialogTerms.querySelector('button[autofocus]');
  if (closeButtonTerms) {
    closeButtonTerms.addEventListener('click', () => {
      dialogTerms.close();
      closeButtonTerms.removeEventListener('click', this);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  agegate();
  quickModalWorkings();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  const packagingOptions = document.querySelectorAll('input[name="packaging"]');
  const packagingTypeInput = document.getElementById('packaging_type');

  packagingOptions.forEach(option => {
    option.addEventListener('change', function() {
      packagingTypeInput.value = this.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    const compass = document.querySelector('.compass');
    const header = document.querySelector('header');

    const firstItem = document.querySelector('.header__menu.main .item');
    if(firstItem == null) return;
    let firstLeft = firstItem.getBoundingClientRect().left - 50 + 'px';
    compassInitialPosition();

    function compassInitialPosition() {
      let firstLeft = firstItem.getBoundingClientRect().left - 50 + 'px';
      compass.style.left = firstLeft;
    }

    function positionCompass(item) {
      if(!item) return;
      header.classList.add('menuhover');
      compass.classList.add('active');
      const itemtop = item.getBoundingClientRect().top;
      const itemHeight = item.getBoundingClientRect().height;
      const middle = itemtop + (itemHeight / 2);
      const itemleft = item.getBoundingClientRect().left;
      compass.style.top = (middle - (compass.offsetHeight / 2) - 13) + 'px';
      compass.style.left = (itemleft - (compass.offsetWidth / 2)) + 'px';
    }

    function resetCompass() {
      compass.classList.remove('active');
      header.classList.remove('menuhover');
      compassInitialPosition();
    }
    resetCompass();

    //get mainMenu items
    const mainMenuItems = document.querySelectorAll('.header__menu.main .item');
    //add event listeners to each item
    mainMenuItems.forEach(item => {
      item.addEventListener('mouseenter', () => positionCompass(item));
    });
    mainMenuItems.forEach(item => {
      item.addEventListener('mouseleave', () => {
        resetCompass();
      });
    });

    //mobile menu
    const mobileMenu = document.querySelector('.mobilemenu');
    const hamburger = document.querySelector('.hamburger');
    const mobileunderlay = document.querySelector('.mobileunderlay');
    const cross = document.querySelector('.mobilemenu .cross');

    function closeMobileMenu() {
      mobileMenu.classList.remove('active');
      mobileunderlay.classList.remove('active');
    }

    function openMobileMenu() {
      mobileMenu.classList.add('active');
      mobileunderlay.classList.add('active');
    }

    hamburger.addEventListener('click', () => {
      openMobileMenu();
    });
    mobileunderlay.addEventListener('click', () => {
      closeMobileMenu();
    });
    cross.addEventListener('click', () => {
      closeMobileMenu();
    });
    window.addEventListener('resize', () => {
      console.log('resize');
      resetCompass();
      compassInitialPosition();
      
      if (window.innerWidth > 1200) {
        closeMobileMenu();
      }
    });
    window.addEventListener('keydown', (event) => {
      if (event.key === "Escape") {
        if( mobileMenu.classList.contains('active') ) {
          closeMobileMenu();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

  const mainImage = document.querySelector('.mainimage img.main');
  const thumbnails = document.querySelectorAll('.thumbnails .product-image');
  let currentIndex = 0;
  const prevButton = document.querySelector('.controls .prev');
  const nextButton = document.querySelector('.controls .next');
  const totalImages = thumbnails.length;

  const addons = document.querySelectorAll('.addontoggle input[type="checkbox"]');
  addons.forEach(addon => {
    addon.addEventListener('change', () => {
      updatePrice();
    });
  });

  if (thumbnails.length > 0) {

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', switchImage);
    });

    function clearThumbnails() {
      thumbnails.forEach(thumb => thumb.classList.remove('active'));
    }
    function switchImage(event) {
      let sourceimage = event.target.src;
      clearThumbnails();
      event.target.classList.add('active');
      mainImage.src = sourceimage;
      mainImage.dataset.count = event.target.dataset.count;
      currentIndex = parseInt(event.target.dataset.count);
    }

    prevButton.addEventListener('click', () => {
      currentIndex = (currentIndex-1 + totalImages) % totalImages;
      updateMainImage();
    });

    nextButton.addEventListener('click', () => {
      currentIndex = parseInt(currentIndex) + 1;
      if (currentIndex >= totalImages) currentIndex = 0;
      updateMainImage();
    });

    function updateMainImage() {
      clearThumbnails();
      const selectedThumbnail = thumbnails[currentIndex];
      selectedThumbnail.classList.add('active');
      mainImage.src = selectedThumbnail.src;
    }
  }

  quantitySelector();
  function quantitySelector() {
    const decreaseButton = document.querySelector('.quantity-button[data-action="decrease"]');
    const increaseButton = document.querySelector('.quantity-button[data-action="increase"]');
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!decreaseButton || !increaseButton || !quantityInput) return;
    decreaseButton.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
      updatePrice();
    });
    increaseButton.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
      updatePrice();
    });
    quantityInput.addEventListener('input', (e) => {
      let currentValue = parseInt(quantityInput.value);
      if (isNaN(currentValue) || currentValue < 1) {
        quantityInput.value = 1;
      }
      updatePrice();
    });
  }


  addToCartFromDropdowns();
  function addToCartFromDropdowns() {
    let addButton = document.querySelector('.addbutton');
    if(!addButton) {
      console.error("No add button found");
      return;
    }
    addButton.addEventListener('click', addToCartProcess);
  }

  optionChanges();
  function optionChanges() {
    const optionSelectors = document.querySelectorAll('select');
    optionSelectors.forEach(select => {
      select.addEventListener('change', () => {
        updatePrice();
      });
    });
  }


  updatePrice(); // Run on initial load
  function updatePrice() {
    const addButton = document.querySelector('.addbutton');
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    const variant = getVariant();
    const addonCheckboxes = document.querySelectorAll('.addontoggle input[type="checkbox"]');
    const extraprice = Array.from(addonCheckboxes).reduce((total, checkbox) => {
      if (checkbox.checked) {
        const addonPriceElement = checkbox.parentElement.querySelector('.addonprice');
        if (addonPriceElement) {
          const addonPrice = parseFloat(addonPriceElement.textContent.replace('$', ''));
          return total + addonPrice;
        }
      }
      return total;
    }, 0);

    if (!addButton) return;

    const isAvailable = !!(variant && variant.available);
    addButton.disabled = !isAvailable;
    addButton.classList.toggle('disable', !isAvailable);

    const buttonTextSpan = addButton.querySelector('.addbutton-text');
    const priceHtml = variant
      ? `Add to cart - $<span class="buttonprice">${((variant.price / 100 + extraprice) * quantity).toFixed(2)}</span>`
      : 'Add to cart - $<span class="buttonprice">N/A</span>';

    if (buttonTextSpan) {
      buttonTextSpan.innerHTML = isAvailable ? priceHtml : 'Sold out';
    } else {
      addButton.innerHTML = isAvailable ? priceHtml : 'Sold out';
    }

    // Keep the hidden variant id input and stock display in sync too
    const idInput = document.getElementById('variant-id-input');
    if (idInput && variant) idInput.value = variant.id;

    const stockNumberEl = document.querySelector('.stocknumber');
    if (stockNumberEl && variant) stockNumberEl.textContent = variant.inventory_quantity;
  }

  function getPrice() {
    const variant = getVariant();
    return variant ? variant.price : null;
  }

  function getVariant() {
    const variantID = getVariantID();
    if (variantID === null) return null;
    return productData.variants.find(v => v.id === variantID) || null;
  }

  function getVariantID() {
    const variants = productData.variants;
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) {
      console.error("No add to cart form found");
      return null;
    }
    const optionSelectors = form.querySelectorAll('select');
    const selectedOptions = Array.from(optionSelectors).map(select => select.value);
    const variant = variants.find(v => {
      return selectedOptions.every((option, index) => v.options[index] === option);
    });

    if (variant) {
      return variant.id;
    }
    return null;
  }

  function addToCartProcess() {

    const variant = getVariant();
    if (!variant || !variant.available) {
      console.error("Cannot add to cart: selected variant is sold out or not found");
      return;
    }

    const variantID = variant.id;
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantity = parseInt(quantityInput.value) || 1;

    const data = {
      'items': [{
        id: variantID,
        quantity: quantity
      }]
    };

    var propertylines = [];
    const addonCheckboxes = document.querySelectorAll('.addontoggle input[type="checkbox"]');
    addonCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const addonVarId = checkbox.dataset.varid;
        data.items.push({
          id: parseInt(addonVarId),
          quantity: quantity
        });
        propertylines.push(`${checkbox.parentElement.querySelector('.addontitle').textContent.trim()}`);
      }
    });
    data.items[0].properties = {
      'Addons': propertylines.join(', ')
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
        window.location.href = '/cart';
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
    });

  }


  } catch(e) { console.error(e); }
})();
})();
